/**
 * Coming Soon Feature
 * Replaces "Sold Out" with "Coming Soon" for variants marked with coming_soon metafield
 */
(function () {
  'use strict';

  const SUBMIT_BUTTON_SELECTOR = '[id^="ProductSubmitButton-"]';

  /**
   * Get variant metafields from the data-variant-metafields JSON script
   */
  function getVariantMetafields() {
    const script = document.querySelector('script[data-variant-metafields]');
    if (!script) return {};
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      console.error('Failed to parse variant metafields:', e);
      return {};
    }
  }

  /**
   * Check if a variant is marked as "coming soon"
   */
  function isComingSoon(variantId) {
    const metafields = getVariantMetafields();
    const variantData = metafields[String(variantId)];
    return variantData?.coming_soon === true;
  }

  /**
   * Update the submit button text for coming soon variants
   */
  function updateSubmitButton(variant) {
    const button = document.querySelector(SUBMIT_BUTTON_SELECTOR);
    if (!button) return;

    const textSpan = button.querySelector('span:first-child');
    if (!textSpan) return;

    // Only update if variant is unavailable
    if (variant.available) return;

    if (isComingSoon(variant.id)) {
      textSpan.textContent = window.variantStrings?.comingSoon || 'Coming Soon';
    } else {
      textSpan.textContent = window.variantStrings?.soldOut || 'Sold Out';
    }
  }

  /**
   * Handle variant change events
   */
  function handleVariantChange(event) {
    const variant = event?.data?.variant;
    if (!variant) return;

    updateSubmitButton(variant);
  }

  /**
   * Initialize the coming soon feature
   */
  function init() {
    // Subscribe to variant change events
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, handleVariantChange);
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
